import React from 'react';
import Dialog from './Dialog';
import { translate } from '../Services/translation';

const BoxDialog = ({ isOpen, onClose, quantity, packageSize, onSelect }) => {
  const qty = parseInt(quantity);
  const roundDown = Math.round(Math.floor(qty / packageSize) * packageSize);
  const roundUp = Math.round(Math.ceil(qty / packageSize) * packageSize);

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div className="box-dialog">
        <div className="box-dialog__header">
          <h2 className="box-dialog__title">
            {translate('buybutton.boxdialog.title')}
          </h2>
          <p className="box-dialog__description">
            {translate('buybutton.boxdialog.description.part1').replace(
              '{quantity}',
              qty
            )}
            {translate('buybutton.boxdialog.description.part2').replace(
              '{packageSize}',
              packageSize
            )}
          </p>
        </div>
        <div className="box-dialog__actions">
          {roundDown > 0 && roundDown !== qty && (
            <button
              className="box-dialog__option"
              onClick={() => onSelect(roundDown)}
            >
              {translate('buybutton.boxdialog.roundto')} {roundDown}
            </button>
          )}
          {roundUp !== qty && (
            <button
              className="box-dialog__option"
              onClick={() => onSelect(roundUp)}
            >
              {translate('buybutton.boxdialog.roundto')} {roundUp}
            </button>
          )}
          <button className="box-dialog__confirm" onClick={() => onSelect(qty)}>
            {translate('buybutton.boxdialog.confirm')} {qty}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default BoxDialog;
